export default __webpack_public_path__ + "static/media/046-touch screen.f45b205c.svg";